<div class="title">
  <mat-icon>corporate_fare</mat-icon>
  Organizations
</div>
<div class="description">SELECT THE ORGANIZATIONS TO FILTER BY</div>

<div class="lightMode search">
  <framework-search-feeds
    [(ngModel)]="feed"
    (chosenFeed)="add($any($event))"
    [placeholder]="'Search Orgs'"
    [resetOnSelected]="true"
    >
  </framework-search-feeds>
</div>

<div class="options">
  @for (org of organizations; track org) {
    <elements-filter-chip
      icon="corporate_fare"
      [caption]="org.displayName"
      [selected]="true"
      (click)="remove(org)"
      suffixIcon="close"
      >
    </elements-filter-chip>
  }
</div>

<div class="actions">
  <button styles-button (click)="close.emit()">Filter</button>
  <button styles-low-button (click)="clear()">Clear</button>
</div>
